import { useEffect } from 'react';
import { useAuth } from '@bymason-private/auth-provider';
import { Box } from '@bymason-private/legacy-pattern-components';
import { useToast } from '@bymason-private/controller-shared-widgets';
import { useGetDashboardMetadata, useGetJobsStatus } from '@bymason/controller-api-hooks';
import Layout from '../../common/layout';
import { BulletPointsSection } from './bullet-point-section';
import GuideLinks from './guide-links';
import MetricsSubheader from './metrics-subheader';
import TwoUpSection from './two-up-section';

export default function DashboardView() {
  const { authToken = '', customerId } = useAuth();
  const [getBuilds, builds, buildsError, buildsBusy] = useGetJobsStatus(authToken);
  const [getDashboard, dashboard, dashboardError, dashboardBusy] = useGetDashboardMetadata(authToken);
  const [setToastMessage, setToastSeverity] = useToast();

  useEffect(() => {
    if (!dashboardBusy && dashboardError) {
      setToastMessage(dashboardError);
      setToastSeverity('error');
    }
  }, [dashboardBusy, dashboardError, setToastMessage, setToastSeverity]);

  useEffect(() => {
    if (!buildsBusy && buildsError) {
      setToastMessage(buildsError);
      setToastSeverity('error');
    }
  }, [buildsBusy, buildsError, setToastMessage, setToastSeverity]);

  useEffect(() => {
    getDashboard({});
    customerId &&
      getBuilds({
        customerId,
      });
  }, [getDashboard, getBuilds, customerId]);

  return (
    <Layout divider={false} headerText='Welcome' busy={dashboardBusy || buildsBusy}>
      <Box sx={{ display: 'flex', gap: 3 }}>
        <Box sx={{ width: 900, gap: 4, display: 'flex', flexDirection: 'column' }}>
          <MetricsSubheader
            provisionedDeviceCount={dashboard?.device_count?.total}
            builds={builds?.data}
            groupCount={dashboard?.group_count?.total}
          />
          <TwoUpSection />
          <BulletPointsSection />
        </Box>
        <GuideLinks />
      </Box>
    </Layout>
  );
}
